import { client } from './setup';
import { BOOKNG_API } from '../globals';

export default {
    sendBookingCheckout: (bookingCheckout) => client.post(`${BOOKNG_API}/checkout`, bookingCheckout),
    sendBookingCheckoutIds: (bookingCheckout)=> client.post(`${BOOKNG_API}/checkout-by-ids`, bookingCheckout)
}